import { useRouterState } from "@tanstack/react-router";
import { type PageEntry, type Section, sectionFor, tabFor } from "@/lib/navigation";

/** The path in view, from the router. */
export function usePathname(): string {
  return useRouterState({ select: (state) => state.location.pathname });
}

/**
 * Where a page sits (lib/navigation.ts): its section, which the rail marks, and its tab when it is
 * one (null on a detail page or a setup step).
 */
export function usePlace(): {
  section: Section | null;
  here: { section: Section; tab: PageEntry } | null;
} {
  const pathname = usePathname();
  return { section: sectionFor(pathname), here: tabFor(pathname) };
}
